module.exports = __webpack_public_path__ + "img/queren.071fd9d2.png";